import React from "react";
export const menus = [
  {
    code: "016",
    en: "Dashboard",
    fa: "داشبورد",
    icon: <i className="fas fa-columns" />,
    link: "/dashboard",
    child: []
  },
  {
    code: "268",
    en: "Setting",
    fa: "تنظیمات",
    icon: <i className="fas fa-columns" />,
    link: null,
    child: [
      {
        code: "270",
        en: "Network Setting",
        fa: "تنظیمات شبکه",
        link: "/Setting/NetworkSetting"
      },
      {
        code: "445",
        en: "Message Configuration",
        fa: "تنظیمات پیام",
        link: "/Setting/MessageConfiguration"
      }
    ]
  },
  {
    code: "273",
    en: "Product Management",
    fa: "مدیریت محصول",
    link: "/ProductManagement",
    icon: <i className="fas fa-headset" />,
    child: []
  },
  {
    code: "274",
    en: "Member Management",
    fa: "مدیریت اعضا",
    link: null,
    icon: <i className="fas fa-headset" />,
    child: [
      {
        code: "275",
        en: "All Members",
        fa: "همه اعضا",
        link: "/AllMembers"
      },
      {
        code: "276",
        en: "Blocked Members",
        fa: "بلاک شده",
        link: "/BlockedMembers"
      },
      {
        code: "528",
        en: "Commercial list",
        fa: "لیست تجاری ها",
        link: "/Commerciallist"
      },
      {
        code: "529",
        en: "Installment premitted list",
        fa: "لیست اقساطی",
        link: "/InstallmentPremittedList"
      },
      {
        code: "443",
        en: "Stuff List",
        fa: "دیگران",
        link: "/StaffList"
      },
      {
        code: "449",
        en: "Role List",
        fa: "دیگران",
        link: "/RoleList"
      }
    ]
  },
  // {
  //   code: "279",
  //   en: "Position Management",
  //   fa: "مدیریت جایگاه",
  //   link: "/PositionManagement",
  //   icon: <i className="fas fa-headset" />,
  //   child: []
  // },
  {
    code: "280",
    en: "Confirmation Management",
    fa: "مدیریت تائیدیه",
    link: null,
    icon: <i className="fas fa-headset" />,
    child: [
      {
        code: "281",
        en: "KYC Confirmation",
        fa: "",
        link: "/KYCConfirmation"
      },
      {
        code: "282",
        en: "Payment Details Confirmation",
        fa: "",
        link: "/PaymentDetailsConfirmation"
      }
    ]
  },
  {
    code: "283",
    en: "Network",
    fa: "شبکه",
    link: "/Network",
    icon: <i className="fas fa-headset" />,
    child: [
      {
        code: "046",
        en: "Direct Referral",
        fa: "معرفی های مستقیم",
        link: "/DirectReferral"
      },
    ]
  },
  {
    code: "284",
    en: "Bonus",
    fa: "پاداش",
    link: null,
    icon: <i className="fas fa-headset" />,
    child: [
      {
        code: "285",
        en: "Network Bonus",
        fa: "پاداش شبکه ای",
        link: "/NetworkBonus"
      },
      {
        code: "286",
        en: "Direct Bonus",
        fa: "پاداش مستقیم",
        link: "/DirectBonus"
      }
    ]
  },
  {
    code: "287",
    en: "B-Wallet",
    fa: "کیف پول",
    link: null,
    icon: <i className="fas fa-headset" />,
    child: [
      {
        code: "271",
        en: "Payment Methods",
        fa: "راه های پرداخت",
        link: "/PaymentMethods"
      },
      {
        code: "288",
        en: "B-Wallet Summery",
        fa: "خلاصه کیف پول",
        link: "/BWalletSummery"
      },
      {
        code: "289",
        en: "Transaction History",
        fa: "تاریخچه تراکنش ها",
        link: "/TransactionHistory"
      },
      {
        code: "290",
        en: "Withdraw Fund",
        fa: "برداشت صندوق",
        link: "/WithdrawFund"
      },
      {
        code: "291",
        en: "Transfer Fund",
        fa: "صندوق انتقال",
        link: "/TransferFund"
      },
      {
        code: "452",
        en: "Incomes",
        fa: "درآمد",
        link: "/Incomes"
      },
      {
        code: "453",
        en: "Paid Bonus",
        fa: "پاداش پرداخت شده",
        link: "/PaidBonus"
      },
    ]
  },
  {
    code: "292",
    en: "Upload Management",
    fa: "مدریت اپلود",
    link: "/UploadManagement",
    icon: <i className="fas fa-headset" />,
    child: []
  },
  {
    code: "293",
    en: "Event Management",
    fa: "مدریت رخداد ها",
    link: "/EventManagement",
    icon: <i className="fas fa-headset" />,
    child: []
  },
  {
    code: "107",
    en: "Support",
    fa: "پشتیبانی",
    link: null,
    icon: <i className="fas fa-headset" />,
    child: [
      {
        code: "106",
        en: "Messages",
        fa: "پیام ها",
        link: "/Messages"
      },
      {
        code: "108",
        en: "Live chat",
        fa: "چت زنده ",
        link: "/chat"
      }
      // {
      //   code: "111",
      //   en: "Whistle Blower Report",
      //   fa: "گزارش تخلف",
      //   link: "/WhistleBlowerReport"
      // }
    ]
  },
  {
    code: "038",
    en: "Security",
    fa: "امنیت",
    link: "/security",
    icon: <i className="fas fa-calculator" />,
    child: []
  },
];
export default menus;
